<template>
    <div>
        <div class="mt-2">
            <h3 class="mt-2" v-if="module_key == 'mm_bituminous_concrete_overlay'">Bituminous Concrete Overlay</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_dense_bituminous_concrete_overlay'">Dense Bituminous Concrete Overlay</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_milling'">Milling</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_thermoplastic_road_marking'">Thermoplastic Road Marking</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_shoulder_raising'">Shoulder Raising</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_road_sruds_fixing'">Road Sruds Fixing</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_kerb_topping'">Kerb Topping</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_kerb_painting'">Kerb Painting/Crash Barrier</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_microsurfacing'">Microsurfacing</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_tack_coat'">Tack Coat</h3>
            <h3 v-else-if="module_key === null">DPR Issue List</h3>
        </div>
        <vs-row v-if="issue_type">
            <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 mb-base">
                <router-link :to="{name: 'dpr-entry-add', params: {issue_type: issue_type, module_key: module_key}}">
                    <vs-button color="primary" type="filled" class="w-full">
                        Create DPR Issue
                    </vs-button>
                </router-link>
            </vs-col>
        </vs-row>
        <template v-if="results && results.length">
            <vx-card v-for="(item, index) in results" :key="index">
                <div class="issue-card p-4 mb-3" slot="no-body" v-if="item.data">
                    <vs-row class="m-0 p-0">
                        <vs-col class="px-0 pr-1" vs-xs="11" vs-sm="11" vs-lg="11">
                            <h4 class="m-0 mb-2">DPR Issue # {{ item.id }}</h4>
                            <small class="block mb-1">
                                <span class="font-bold"> Upload Status: {{ item.status }}</span>
                            </small>
                            <small class="block">
                                <span class="font-bold">Created at:</span> <FormatText :text="item.timestamp" format="datetime" />
                            </small>
                        </vs-col>
                        <vs-col class="px-1 text-right flex" vs-align="center" vs-xs="1" vs-sm="1" vs-lg="1">
                            <template v-if="item.status == 'draft'">
                                <router-link :to="{name: 'cache-dpr-entry-edit', params: {issue_type: issue_type, module_key: module_key, dpr_entry_id: item.id}}">
                                    <vs-button type="flat" class="px-1 py-1" size="large" color="primary">
                                        <font-awesome-icon :icon="rightIcon" />
                                    </vs-button>
                                </router-link>
                            </template>
                            <template v-else>
                                <router-link :to="{name: 'cache-dpr-entry-view', params: {issue_type: issue_type, module_key: module_key, dpr_entry_id: item.id}}">
                                    <vs-button type="flat" class="px-1 py-1" size="large" color="primary">
                                        <font-awesome-icon :icon="rightIcon" />
                                    </vs-button>
                                </router-link>
                            </template>
                        </vs-col>
                    </vs-row>
                </div>
            </vx-card>
        </template>
        <template v-else>
            <vx-card>
                <h4 class="text-center">Data Not Available!</h4>
            </vx-card>
        </template>
    </div>
</template>

<script>
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
export default {
    data() {
        return {

            issue_type: this.$route.params.issue_type,
            module_key: this.$route.params.module_key,
            results: [],
            api_errors: null,
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        issue_type(newV, oldV) {
            if (newV === oldV) return
            this.load_data()
        },
        module_key(newV, oldV) {
            if (newV === oldV) return
            this.load_data()
        },
        "$route.params.issue_type"(newV, oldV) {
            this.issue_type = newV
        },
        "$route.params.module_key"(newV, oldV) {
            this.module_key = newV
        }
    },
    computed: {
        rightIcon: () => faChevronRight,
    },
    methods: {
        init() {
            this.load_data()
        },
        async load_data() {
        
            this.api_errors = {}
            let key = `dpr_issues__${this.module_key}`
            let res = await this.$ionicStorage.get(key)
            
            let data = JSON.parse(res)

            if (data && this.$route.query.is_failed) {
                this.results = data.filter(obj => obj.status == 'draft')
            } else {
                this.results = data
            }
        }
    }
}
</script>